import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes } from "@bundles/UIAppBundle";
import { useUIComponents, useRouter, use, useTranslate } from "@bluelibs/x-ui";
import * as Ant from "antd";
import { UserCreateForm } from "../../config/UserCreateForm";
import { useMutation } from "@apollo/client";
import { AddUser } from "@bundles/UIAppBundle/mutations/AddUser";
import { SmileOutlined } from "@ant-design/icons";
import { useState } from "react";
const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export function UsersCreate() {
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const form = use(UserCreateForm, { transient: true });
    form.build();
    const [loading, setLoading] = useState(false);
    const [addUser] = useMutation(AddUser);
    const handleAddUser = (document) => {
        setLoading(true);
        addUser({
            variables: {
                input: document,
            },
        })
            .then((res) => {
            var _a;
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.users.create_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            const userId = (_a = res.data) === null || _a === void 0 ? void 0 : _a.addUser;
            if (userId) {
                router.go(Routes.USERS_VIEW, {
                    params: { id: userId },
                });
            }
        })
            .catch((err) => {
            switch (err.message) {
                case "Username already exists":
                    Ant.notification.warn({
                        message: t("generics.error"),
                        description: t("management.users.errors.username_already_exists"),
                    });
                    break;
                default:
                    Ant.notification.warn({
                        message: t("generics.error"),
                        description: t("generics.error_message"),
                    });
                    break;
            }
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return (_jsxs(UIComponents.AdminLayout, { children: [_jsx(Ant.PageHeader, { title: t("management.users.create.header"), onBack: () => window.history.back() }, void 0), _jsx(Ant.Card, { children: _jsxs(Ant.Form, Object.assign({}, formLayout, { requiredMark: "optional", onFinish: handleAddUser }, { children: [form.render(), _jsx(Ant.Form.Item, Object.assign({}, formTailLayout, { children: _jsx(Ant.Button, Object.assign({ loading: loading, type: "primary", htmlType: "submit" }, { children: t("generics.submit") }), void 0) }), void 0)] }), void 0) }, void 0)] }, void 0));
}
